// The workspace's alert channels that can't take an alert, by the value a setup question offers
// them under, with the sentence that says why (v3 `useUnavailableChannels.js`). Read through module
// 22's channel seam. Settings that can't be read grey nothing out: the save still refuses a closed
// channel, so this only spares the user a turn.
import { computed, onMounted, watch, type ComputedRef } from 'vue'

import { useWorkspace } from '@/features/account'
import { useNotificationChannels } from '@/features/workspace-settings'
import { useI18n } from '@/shared/i18n'

// The setup question's channel values are the alert write's own (`channel_type`): email is `mail`.
const SETUP_VALUE: Record<string, string> = {
  email: 'mail',
  whatsapp: 'whatsapp',
  slack: 'slack',
  teams: 'teams',
}

export function useUnavailableChannels(): ComputedRef<Record<string, string>> {
  const { t } = useI18n()
  const { workspaceId } = useWorkspace()
  const channels = useNotificationChannels()

  onMounted(() => void channels.refresh())
  watch(workspaceId, () => void channels.refresh())

  return computed(() => {
    if (channels.state.value !== 'ready') return {}
    return Object.fromEntries(
      channels.availability.value.flatMap((entry) => {
        const value = SETUP_VALUE[entry.channel]
        if (!value) return []
        if (!entry.configured) return [[value, t('orpheus.setup.channelNotConfigured')]]
        if (!entry.enabled) return [[value, t('orpheus.setup.channelTurnedOff')]]
        return []
      }),
    )
  })
}
